import { AspectRatio, Box, SimpleGrid, Skeleton } from '@chakra-ui/react';
import { rem } from 'polished';

const NFTCardSkeleton = () => (
  <Box bg="gray.2" border="1px" borderColor="gray.4" h="full" rounded="radius.28" overflow="hidden">
    <AspectRatio ratio={1 / 1}>
      <Skeleton rounded="none" />
    </AspectRatio>
    <SimpleGrid p="space.12" gap="space.32" columns={2} mt="0.5px">
      <Skeleton h={rem(20)} />
      <Skeleton h={rem(20)} ml="space.32" />
    </SimpleGrid>
  </Box>
);

export default NFTCardSkeleton;
